module.exports = __webpack_public_path__ + "static/assets/ddd611ec4734ba01baaac0a0371f4666.svg";